import { render, staticRenderFns } from "./coachAssessmentDetail.vue?vue&type=template&id=05bcac2b&scoped=true"
import script from "./coachAssessmentDetail.vue?vue&type=script&lang=js"
export * from "./coachAssessmentDetail.vue?vue&type=script&lang=js"
import style0 from "./coachAssessmentDetail.vue?vue&type=style&index=0&id=05bcac2b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bcac2b",
  null
  
)

export default component.exports